import { Text, View, ScrollView, Pressable } from "react-native";
import Tile from "../../components/TilesList/Tile";
import ValidationCard from "./ValidationCard.component";
import styles from './EspaceValideur.styles';
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { useRef } from "react";
import { AccueilEspaceValideurProps } from "./EspaceValideur.types";

export default function AccueilEspaceValideur({ demandes, onMoreClicked, openPlanning, onReject, onValidate }: AccueilEspaceValideurProps) {
    const containerRef = useRef<View>(null);
    return (
        <ScrollView>
            <Text style={styles.sectionTitle}>ABSENCES ET CONGÉS</Text>
            <Tile
                tile={{
                    id: 1,
                    title: "Planning du jour",
                    subtitle: "Voir le planning",
                    route: "Planning",
                    icon: "account-multiple-outline",
                    color: "#3b82f6",
                    background: "#f9fafb"
                }}
                onPress={openPlanning}
            />
            <Text style={styles.sectionTitle}>A VALIDER</Text>
            <View style={styles.reducedCardsListContainer}>
                <View ref={containerRef} style={styles.validationCardContainer}>
                    {demandes.length > 0 ? demandes.map((demande) => (
                        <ValidationCard
                            key={demande.identifiant}
                            demande={demande}
                            onReject={onReject}
                            onValidate={onValidate}
                        />
                    )) : (
                        <Text>Aucune demande d'absence à valider</Text>
                    )}
                </View>
            </View>

            {containerRef.current?.clientHeight && containerRef.current?.clientHeight > 480 && (
                <Pressable style={styles.voirToutContainer} onPress={onMoreClicked}>
                    <Text style={styles.voirToutText}>VOIR TOUT</Text>
                    <MaterialCommunityIcons
                        name="chevron-right"
                        size={16}
                        color="#D6330D"
                    />
                </Pressable>
            )}
        </ScrollView>
    )
}
